import React from 'react';
import Card from '../../common/Card';
import { Skeleton } from '../../common/Skeleton';
import './agentic-flow-card-skeleton.scss';

/**
 * Skeleton loader for Agentic Flow cards.
 * Matches the layout: avatar + title, description lines, action buttons.
 */
const AgenticFlowCardSkeleton: React.FC = () => (
  <Card>
    <div className="agentic-flow-card-skeleton">
      <div className="agentic-flow-card-skeleton__header">
        <Skeleton width={48} height={32} className="agentic-flow-card-skeleton__avatar skeleton--delay-1" />
        <Skeleton width={160} height={18} className="skeleton--delay-2" />
      </div>
      <div className="agentic-flow-card-skeleton__body">
        <Skeleton width="100%" height={14} className="skeleton--delay-3" />
        <Skeleton width="100%" height={14} className="skeleton--delay-4" />
        <Skeleton width="100%" height={14} className="skeleton--delay-5" />
        <Skeleton width="70%" height={14} className="skeleton--delay-6" />
      </div>
      <div className="agentic-flow-card-skeleton__actions">
        <Skeleton width={60} height={32} className="agentic-flow-card-skeleton__btn skeleton--delay-7" />
        <Skeleton width={90} height={32} className="agentic-flow-card-skeleton__btn skeleton--delay-8" />
      </div>
    </div>
  </Card>
);

export default AgenticFlowCardSkeleton;
